import { MessageBox } from "element-ui";
import api from "@/api/api";

let historyVersion = localStorage.getItem("version"); //当前版本号
let currentVersion = undefined; //最新版本号
let countdownFunction;

//倒计时
function countdown() {
  countdownFunction = setInterval(() => {
    getCurrentVersion();
  }, 5 * 60 * 1000);
}

//获取最新版本地址
function getCurrentVersion() {
  api.dictionary
    .getDictionary({
      name: "总后台版本"
    })
    .then(res => {
      if (!historyVersion) {
        localStorage.setItem("version", res.data.remark);
      } else if (historyVersion != res.data.remark) {
        currentVersion = res.data.remark;
        clearInterval(countdownFunction);
        //提示更新
        updataMsg();
      }
    });
}

function updataMsg() {
  MessageBox.confirm("有新版本发布，是否需要更新?", "提示", {
    confirmButtonText: "确定",
    cancelButtonText: "30分钟后提醒我",
    type: "warning"
  })
    .then(() => {
      //刷新页面，更新版本
      localStorage.setItem("version", currentVersion);
      window.location.reload();
    })
    .catch(() => {
      //30分钟后继续倒计时获取版本
      setTimeout(() => {
        countdown();
      }, 30 * 60 * 1000);
    });
}

countdown();



// WEBPACK FOOTER //
// ./static/js/versionControl.js